(() => {
  document.querySelectorAll('[data-everstay-activity-toast]').forEach((toast) => {
    const messages = [...toast.querySelectorAll('[data-everstay-activity-message]')];
    const title = toast.querySelector('[data-everstay-activity-title]');
    const copy = toast.querySelector('[data-everstay-activity-copy]');
    const closeButton = toast.querySelector('[data-everstay-activity-close]');
    if (!messages.length || !title || !copy) return;

    try {
      if (window.sessionStorage.getItem('everstay-activity-dismissed') === 'true') return;
    } catch (_) {
      // The toast still works when storage is unavailable.
    }

    let messageIndex = 0;
    let hideTimer;
    let firstTimer;

    const hideActivity = () => toast.classList.remove('is-visible');

    const showNextActivity = () => {
      const message = messages[messageIndex % messages.length];
      title.textContent = message.dataset.title;
      copy.textContent = message.dataset.copy;
      messageIndex += 1;
      toast.classList.add('is-visible');
      window.clearTimeout(hideTimer);
      hideTimer = window.setTimeout(hideActivity, 3000);
    };

    firstTimer = window.setTimeout(showNextActivity, 1200);
    const activityInterval = window.setInterval(showNextActivity, 5000);

    closeButton?.addEventListener('click', () => {
      window.clearTimeout(firstTimer);
      window.clearTimeout(hideTimer);
      window.clearInterval(activityInterval);
      hideActivity();
      try {
        window.sessionStorage.setItem('everstay-activity-dismissed', 'true');
      } catch (_) {
        // Dismissal still applies for the current page.
      }
    });
  });
})();
